export default "/_next/static/images/co-development-bg@2x-9cc4acbe81b2a9d11bc02510acabc3e9.webp";